import { Box, useRadio } from '@chakra-ui/react';

const RadioCard = (props) => {
    const { getInputProps, getRadioProps } = useRadio(props)
  
    const input = getInputProps()
    const checkbox = getRadioProps()
  
    return (
      <Box as='label' width={130} textAlign='center'>
        <input {...input} />
        <Box
          {...checkbox}
          cursor='pointer'
        //   borderWidth='1px'
          borderRadius='6px'
          boxShadow='lg'
          bg='gray.100'
          fontWeight='500'
          fontSize='17'
          _checked={{
            bg: 'teal.500',
            color: 'white',
          }}
          py={3}
        >
          {props.children}
        </Box>
      </Box>
    )
  };

export default RadioCard;